import Rollbar from 'rollbar';
import { get, matchesProperty, overEvery } from 'lodash-es';
import { ExpectedError } from './errors';

declare global {
    interface Window {
        rollbarConfig?: Rollbar.Configuration;
        Rollbar?: Rollbar;
    }
}

// eslint-disable-next-line import/no-mutable-exports
let rollbar: Rollbar | null = null;

if (typeof window !== 'undefined' && window.rollbarConfig) {
    const isApolloIgnoredError = overEvery(
        matchesProperty('body.trace.exception.class', 'ApolloError'),
        (payload: Rollbar.Payload) =>
            (get(payload, 'body.trace.exception.description', '') as string).startsWith(
                'Network error:'
            )
    );

    rollbar = new Rollbar({
        ...window.rollbarConfig,
        checkIgnore(isUncaught: boolean, args: unknown[], payload: Rollbar.Payload) {
            if (isUncaught) {
                const uncaughtError = args[1];
                // Our system can raise `ExpectedError`'s which do not need to get
                // logged to Rollbar.
                if (uncaughtError instanceof ExpectedError) {
                    return true;
                }
            }

            // Since we have already sent a more detailed version of a network work
            // error in the error handler of the Apollo Client ourselves, we want to
            // stop error propagation. Since it is currently not possible in the
            // Apollo Client to ignore network issues, we filter them here and prevent
            // them from being sent.
            return isApolloIgnoredError(payload);
        },
        scrubFields: [
            ...(window.rollbarConfig.scrubFields || []), // Preserve existing scrubFields
            'auth-password', // Scrub 'auth-password' fields
        ],
    });

    window.Rollbar = rollbar;
}

export default rollbar;
